import { Injectable } from '@angular/core';

import { EntityIdType, createEntityCollections } from '@angular-ru/cdk/entity';
import { DataAction, Payload, StateRepository } from '@angular-ru/ngxs/decorators';
import { NgxsDataEntityCollectionsRepository } from '@angular-ru/ngxs/repositories';
import { State } from '@ngxs/store';

import { ConnectedUser } from './connected-users.model';

@StateRepository()
@State({
  name: 'connectedUsers',
  defaults: createEntityCollections(),
})
@Injectable({ providedIn: 'root' })
export class ProjectConnectedUsersState extends NgxsDataEntityCollectionsRepository<ConnectedUser> {
  public selectId(entity: ConnectedUser): EntityIdType {
    return entity.id;
  }

  @DataAction()
  connectUser(@Payload('user') user: ConnectedUser): void {
    this.upsertOne(user);
  }

  @DataAction()
  disconnectUser(@Payload('userId') userId: string): void {
    this.removeOne(userId);
  }
}
